import { render, staticRenderFns } from "./RehabCoursesTabbar.vue?vue&type=template&id=10af08a6&scoped=true"
import script from "./RehabCoursesTabbar.vue?vue&type=script&lang=js"
export * from "./RehabCoursesTabbar.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesTabbar.vue?vue&type=style&index=0&id=10af08a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af08a6",
  null
  
)

export default component.exports